module.exports = __webpack_public_path__ + "img/16l013-15.c3f98984.png";